export default {
  'changePhoneNum': 'Modify mobile number',
  'changeEmailAdd': 'Modify email address',
  'byPhone': 'Mobile Verification',
  'byEmail': 'Email Verification',
  'phoneNum': 'Mobile number',
  'email': 'Email',
  'address': 'Address',
  'password': 'Password',
  'language': 'Language',
  'reset': 'Modify Password',
  'editPassword': 'Modify Password',
  'replace': 'Change',
  'change': 'Change',
  'p1': 'To add a bank account, please contact customer service',
  'resetTradeAccount': 'Reset Trading Account Password',
  'resetPassword': 'Reset',
  'mt5label': 'Leveraged Foreign Exchange Account',
  'PMlabel': 'Gold Trading Account',
  'stocksecuritiesCashlabel': 'Securities Account (Cash)',
  'stocksecuritiesMarginlabel': 'Securities Account (Margin)',
  'futuresMarginlabel': 'Futures Account',
  'futuresDayTradingMarginlabel': 'Intra-Futures Day Trading Account',
  'changePhoneNotice': 'This feature is only available for mainland customers',
  'changeMt5Pwd': 'Modify Forex Account Trade Password',
  'pwdTip': 'The new password must be a combination of uppercase and lowercase letters and numbers, and be 6-15 digits in length',
  'masterPwd': 'Modify master password',
  'pleaseEnterMaterPwd': 'Please enter master password',
  'readOnlyPwd': 'Modify read-only password',
  'forgetPwd': 'Forgot Password',
  'modifyPwdSuccss': 'Password changed successfully',
  'modifyPwdSuccssTip': 'You have successfully change your password. Please log in with the new password.',
  'resetPwd': 'Reset Password',
  'resetPwdTip': 'You are resetting your Foreign Exchange password. Click on the OK button and we will send the password to your registered email address <{email}> in 5 minutes. Confirm to reset?',
  'commitSuccess': 'Submitted Successfully',
  'commitSuccessTip': 'Please enter registered < {email} > to check your password',
  '404': 'Not found',
  '405': 'Password mismatch',
  '406': 'User ID does not exist',
  '407': 'Parameter mismatch',
  '408': 'New password does not match confirmed password',
  '409': 'Previous password does not match original password',
  '410': 'Missing parameter',
  '411': 'Parameter key is not allowed',
  '412': 'Password length must be 6-12 digits ',
  '7000': 'Incorrect old password',
  '7001': 'Failed to modify password',
  '5003': 'Failed to send email for password reset',
  '10000': 'Failed to modify tranding account',
  '90000': 'Please contact the Administrator for the unauthorised account.',
  '90001': 'Incorrect account number and password',
  '90002': 'Incorrect account number and password',
  '90003': 'Incorrect account number and password',
  '90004': 'The new password does not match the format',
  '90005': 'Incorrect login account or password',
  '90006': 'Incorrect login account or password',
  '90007': 'No feedback for password modification',
  '90008': 'Incorrect login account or password',
  '90009': 'Incorrect login account or password',
  '90010': 'Frequent operations detected, please try again later',
  '90011': 'The password has already been used',
  '10002': 'Incorrect account or password',
  '10004': 'The account is not authorized. Please contact customer service',
  '10008': 'Incorrect login account or password',
  '-986': 'Frequent operations. Please try again later',
  '-989': 'Password change error, please try again later',
  '12001': 'Incorrect login account or password',
  '12003': 'The new password does not meet the requirements',
  '12002': 'The password has already been used',
  '10013': 'Incorrect password. The account is frozen. Please contact customer service',
  '10012': 'The account is frozen. Please contact customer service',
  '5008': 'Failure to receive vertification code due to error in cell phone format',
  '40000': 'Failed to obtain verification code. Please contact customer service',
  'setPassword': {
    '4001': 'User does not exist',
    '4014': 'User source error',
    '4006': 'Password length between 6 to 16 digits',
    '4010': 'Paameter missing',
    '4008': 'New password does not match confirmed password',
    '4009': 'Previous password does not match original password',
    'title': 'Change personal center password',
    'oldPassword': 'Enter your old password',
    'newPassword': 'Enter your new password',
    'confirmPassword': 'Enter your new password again',
    'submit': 'Submit',
    'cancel': 'Cancel',
    'checkPassword': 'Password must consist of 6-16 digits and letters',
    'checkTradePassword': 'Incorrect password format',
    'checkPassWrongLen': 'Password length between 6 to 16 digits',
    'passwordInconsistent': 'Passwords do not match',
    'fail': 'Failed to modify password',
    'resetPhoneFail': 'Failed to modify phone number',
    'notMatch': 'Incorrect old password. Please enter again'
  },
  'confirm': {
    'title': 'Success',
    'p1': 'You have successfully modified the password',
    'p2': 'Please enter with the new password',
    'back': 'Return to Login'
  },
  'changePhone': {
    'title': 'Modify Mobile Phone Number',
    'phoneTitle': 'Current Mobile Phone Number',
    'subtitle': 'You are changing your verified phone number! After the change, you can use the new phone number to log in and recover your password',
    'codeInput': 'Please enter the valid verification code',
    'phoneInput': 'Please enter your mobile number',
    'phoneErr': 'Please enter the correct mobile number',
    'areaErr': 'Please select area code',
    'success': 'Mobile number has been successfully modified',
    'expired': 'Verification code has expired',
    '413': 'The mobile number has already been registered',
    '4003': 'The mobile number has already been registered',
    '4001': 'Incorrect user information',
    'registered': 'The mobile number has already been bound',
    'verCodeFail': 'Incorrect verification code. Please enter again.',
    'phoneNumPlaceholder': 'Mobile Number',
    'verCodePlaceholder': 'Please enter',
    'sendVerTip': 'Get Verification Code',
    'resetPhoneFail': 'Failed to modify phone number',
    'samePhone': 'The mobile phone number is the same as the currently bound mobile phone number',
    'sendSuccess': 'Verification code has been sent to your phone'
  },
  'changePasswordMt5': {
    '30000': 'Please fill in the password',
    '30001': 'Password complexity is insufficient, please reset',
    '30002': 'Please enter a password consisting of 6-15 digits, as well as uppercase and lowercase letters and numbers',
    'messageVerify': 'SMS Verification',
    'emailVerify': 'Email Verification',
    'inputNewPassword': 'Please enter a new password',
    'inputNewPasswordAgain': 'Please enter the new password again',
    'title': 'Enter a new password',
    'checkPassword': 'Please enter a password consisting of 6-15 digits, as well as uppercase and lowercase letters and numbers'
  },
  'changeEmail': {
    '413': 'The email has already been registered',
    '4003': 'The email has already been registered',
    '11013': 'Failed to modify the phone number, please contact customer service',
    'emailEmpty': 'Email cannot be blank',
    'emailErr': 'Please enter the correct email address',
    'emailSame': 'The email is the same as the currently bound email',
    'success': 'Email successfully modified',
    'changeEmailFail': 'Failed to modify email '
  },
  'editAccountPassword': {
    'securitiesMarginTitle': 'Modify Securities (Margin) Trade Password',
    'securitiesCashTitle': 'Modify Securities (Cash) Trade Password',
    'futuresMarginTitle': 'Modify Futures Trade Password',
    'futuresDayTradingMarginTitle': 'Modify Intra-Futures Day Trade Password'
  }
}
